// extracted by mini-css-extract-plugin
export var orderDetails = "_tg-2";
export var orderImage = "_tg-1";
export var orderMeta = "_tg-3";
export var orderSummary = "_tg-0";
export var rightArrow = "_tg-4";